// Build Products
BCSfFilter.prototype.buildSuggestionProductList = function(searchTerm, itemData, ul, itemInfo, suggestionData) {
  var result = '';
  // Buid Header
  result += this.buildSuggestionHeader(itemInfo['label'], 'product');
  // Build Did you mean
  var dym = this.buildSuggestionDidYouMean(searchTerm, suggestionData, ul);
  if (dym != '') {
    result += '<li class="' + this.class.searchSuggestionItem + ' bc-sf-search-suggestion-dym" aria-label="Did you mean">' + dym + '</li>';
  }
  // Build content
  if (Object.keys(itemData).length > 0) {
    // var count = 0;
    for (var k = 0; k < itemData.length; k++) {
      var product = itemData[k];
      // If the product has the 'wholesale' in the title, tag, product_type, don't show that product
      if(product.title.indexOf('wholesale') != -1 || product.product_type == 'wholesale'){
         continue;
      }
      // if (count < itemInfo['number']) {

      // Get product attributes
      var productTitle = this.customizeSuggetionProductTitle(product['title'], searchTerm, itemData);
      productTitle = this.highlightSuggestionResult(productTitle, searchTerm);
      var productUrl = this.buildProductItemUrl(product, false);
      var productThumb = product['images_info'].length > 0 ? this.optimizeImage(product['images_info'][0]['src'], '200x') : bcSfFilterConfig.general.no_image_url;
      var productSku = product.skus !== null && product.skus.length > 0 ? product['skus'][0] : '';
      // Get custom class / attribute
      var searchSuggestionClass = this.class.searchSuggestion;
      var newTabAttr = this.getSettingValue('search.openProductNewTab') ? 'target="_blank"' : '';
      result += '<li class="' + this.class.searchSuggestionItem + ' ' + this.class.searchSuggestionItem + '-product" aria-label="' + this.escape(itemInfo['label']) + ': ' + this.escape(product['title']) + '">';
      result += '<a href="' + productUrl + '" ' + newTabAttr + '>';
      // Build Left column
      if (this.getSettingValue('search.showSuggestionProductImage')) {
        result += '<div class="' + searchSuggestionClass + '-left"><img src="' + productThumb + '" /></div>';
      }
      // Build Right column
      result += '<div class="' + searchSuggestionClass + '-right">';
      result += '<div class="' + searchSuggestionClass + '-product-title">' + productTitle + '</div>';
      if (this.getSettingValue('search.showSuggestionProductSku')) {
        result += '<div class="' + searchSuggestionClass + '-product-sku">SKU: ' + productSku + '</div>';
      }
      if (this.getSettingValue('search.showSuggestionProductVendor')) {
        result += '<div class="' + searchSuggestionClass + '-product-vendor">' + product['vendor'] + '</div>';
      }
      result += this.buildSuggestionProductPrice(product);
      result += '</div>'; // End Right column
      result += '</a>'; // End a
      result += '</li>'; // End li
      // count++;
      // } else break;
    }
  }
  return result;
};


// Build Popular Suggestions
BCSfFilter.prototype.buildSuggestionPopular = function(searchTerm, itemData, ul, itemInfo, suggestionData) {
  var result = '';
  if (Object.keys(itemData).length > 0) {
    // Build content
    var result = this.buildSuggestionHeader(itemInfo['label'], 'popular');
    for (var k in itemData) {
      // If the search term has the 'wholesale' in the title, tag, product_type, don't show that search term
      if (itemData[k].indexOf('wholesale') != -1) {
        continue;
      }
      // if (k < itemInfo['number']) {
      var searchResult = this.highlightSuggestionResult(itemData[k], searchTerm);
      result += '<li class="' + this.class.searchSuggestionItem + '" aria-label="' + this.escape(itemInfo['label']) + ': ' + this.escape(itemData[k]) + '">';
      result += '<a href="' + this.buildSearchLink(itemData[k]) + '">' + searchResult + '</a>';
      result += '</li>';
      // }
    }
  }
  return result;
};
